.model {
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  justify-content: space-between;
}

.body {
  overflow: auto;
  margin-top: 12px;
  max-height: calc((100vh - 235px) * 0.8);
  padding: 20px;
  width: 500px;

  &> .body {
    padding: 5px;
    margin: 0;
    width: auto;
  }
}

.header {
  display: flex;
  align-items: center;
  .select {
    width: 150px;
    margin: auto 20px;
  }
}



.field {
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  &.hidden {
    display: none;
  }
  .filedLabel {
    text-align: left !important;

    width: 160px;
    flex-shrink: 0;
  }

  & > div {
    margin: 0;
  }
}